import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "@/store/apis/baseQuery";

/**
 * Base API. El codegen (`npm run generate:api`) extiende esto con
 * `injectEndpoints` y genera `adminApi.generated.ts`.
 *
 * `tagTypes` se declaran acá (no en `enhanceEndpoints`) para que
 * TypeScript propague los tag types a `providesTags` /
 * `invalidatesTags` en `adminApi.enhanced.ts`. Mismo truco que el
 * proyecto móvil (documentado en su CLAUDE.md).
 */
export const adminApi = createApi({
  reducerPath: "adminApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Session",
    "Me",
    "AdminUser",
    "AdminUsers",
    "Roles",
    "Summary",
    "Advice",
    "AdviceItem",
    "AdviceCategory",
    "AdviceCategoryItem",
    "Popup",
    "Popups",
    "CircleGroup",
    "CircleGroups",
    "AuditLog",
  ],
  endpoints: () => ({}),
});
